module.exports = __webpack_public_path__ + "assets_1775109859079/img/pic.cd38b695.png";